import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux"; 
import Calendar from "./Calendar";

const Details = () => {
  const user = useSelector((state) => state.user.data);
  const authToken = useSelector((state) => state.auth.authToken);
  const [userDetails, setUserDetails] = useState({ username: "", email: "" });
  const [isEditing, setIsEditing] = useState(false);
  const [newUsername, setNewUsername] = useState("");
  const [isAvailable, setIsAvailable] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      setUserDetails({ username: user.username, email: user.email });
    }
  }, [user]);

  useEffect(() => {
    if (newUsername) {
      if (newUsername.length < 6 || newUsername.length > 10) {
        setIsAvailable(false);
      } else {
        const checkAvailability = async () => {
          try {
            const response = await fetch(
              `https://api-wish3s.vercel.app/auth/available/${newUsername}`
            );
            const data = await response.json();
            setIsAvailable(data.available);
          } catch (error) {
            console.error("Error checking username availability:", error);
          }
        };

        checkAvailability();
      }
    }
  }, [newUsername]);

  const handleEditSubmit = async () => {
    if (!isAvailable) {
      setMessage("Username is not available.");
      return;
    }

    try {
      const response = await fetch("http://localhost:5001/auth/edit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ newUsername, token: authToken }),
      });

      const data = await response.json();
      if (response.ok) {
        setUserDetails((prev) => ({ ...prev, username: newUsername }));
        setIsEditing(false);
        navigate("/profile")
      } else {
        setMessage(data.message || "Error updating username.");
      }
    } catch (error) {
      console.error("Error updating username:", error);
    }
  };


  return (
<div className="flex flex-col items-center justify-center h-screen text-center px-4">
  {userDetails.username && userDetails.email ? (
    <div className="w-full max-w-sm md:max-w-md lg:max-w-lg mx-auto">
      <p className="mb-4 break-words">
        <strong>Name:</strong>{" "}
        {isEditing ? (
          <div className="inline-flex items-center gap-2">
            <input
              type="text"
              className="border rounded-md p-2 w-full"
              value={newUsername}
              onChange={(e) => setNewUsername(e.target.value)}
              placeholder="Edit username"
            />
            <button
              onClick={handleEditSubmit}
              className={`px-4 py-2 rounded-md ${
                isAvailable
                  ? "bg-green-500 text-white"
                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
              }`}
              disabled={!isAvailable}
            >
              Save
            </button>
            <button
              onClick={() => setIsEditing(false)}
              className="px-4 py-2 bg-red-500 text-white rounded-md"
            >
              Cancel
            </button>
          </div>
        ) : (
          <>
            {userDetails.username}{" "}
            <button
              onClick={() => {
                setNewUsername(userDetails.username);
                setIsEditing(true);
              }}
              className="ml-2"
            >
              ✏️
            </button>
          </>
        )}
      </p>
      <p className="mb-4">
        <strong>Email:</strong> {userDetails.email}
      </p>
    </div>
  ) : (
    <p>Unable to load profile details. Please check your token.</p>
  )}
  {message && <p className="text-red-500 mt-4">{message}</p>}
  <Calendar />
</div>

  );
};

export default Details;
